<template>
  <page title="报价查询">
    <div>
      <div class="form price-page" v-show="formShow">
        <mt-field
          label="目的地/仓库代码"
          placeholder="选择目的地/仓库代码"
          class="mt-gap"
          v-model.trim="search.countryName"
          readonly
          @click.native="openDestination"
        >
          <img
            v-if="search.countryName"
            src="../assets/locationh.png"
            alt=""
            class="input-icon2"
          />
          <img v-else src="../assets/location.png" alt="" class="input-icon2" />
        </mt-field>
        <mt-field
          label="实重"
          placeholder="输入实重"
          v-model.trim="search.weight"
          type="number"
        >
          <span style="color: #26a2ff" v-if="search.weight">KG</span>
          <span style="color: #ccc" v-else>KG</span>
        </mt-field>
        <!--<mt-cell title="材重" class="price-cell">
                  <mt-field placeholder="长度" v-model.trim="long"></mt-field>
                  <b>*</b>
                  <mt-field placeholder="宽度" v-model.trim="width"></mt-field>
                  <b>*</b>
                  <mt-field placeholder="高度" v-model.trim="height"></mt-field>
                  <span v-if="long&&width&&height" style="padding-right: 10px;color: #26a2ff;">CM</span>
                  <span v-else style="padding-right: 10px;color: #ccc;">CM</span>
                </mt-cell>-->
        <mt-field
          label="类型"
          placeholder="选择类型"
          v-model="search.packageType"
          readonly
          @click.native="popupVisible = true"
        >
          <img
            v-if="search.packageType"
            src="../assets/typeh.png"
            alt=""
            class="input-icon"
          />
          <img v-else src="../assets/type.png" alt="" class="input-icon" />
        </mt-field>
        <mt-field
          label="渠道大类"
          placeholder="全部大类"
          v-model="search.transCategoryName"
          readonly
          @click.native="popupVisible2 = true"
        >
        </mt-field>
        <mt-field
          label="邮编"
          placeholder="输入收件邮编"
          v-model.trim="search.postCode"
        >
        </mt-field>
        <mt-field
          label="报关方式"
          v-model="search.declareMethod"
          readonly
          @click.native="popupVisible4 = true"
        >
        </mt-field>
        <mt-field
          label="付款方式"
          v-model="payType"
          readonly
          @click.native="popupVisible5 = true"
        >
        </mt-field>
        <mt-field
          label="税金方式"
          v-model="payment"
          readonly
          @click.native="popupVisible6 = true"
        >
        </mt-field>
        <!-- <mt-field label="业务类型" placeholder="选择业务类型" v-model="search.businessTypes" readonly
                          @click.native="popupVisible3=true">
                </mt-field> -->
      </div>
      <div class="padded mt-gap2">
        <mt-button type="primary" style="width: 100%" @click="searchData()"
          >查询</mt-button
        >
      </div>
      <div style="background: #fff; margin-top: 20px" v-show="initSearch">
        <p class="search-title">查询条件</p>
        <div class="search-list">
          <span>目的地：{{ search.countryName }}</span>
          <span>实重：{{ search.weight }}KG</span>
          <span>类型：{{ search.packageType }}</span>
          <span
            v-show="
              search.companyNo.toUpperCase() === 'JLTY' ||
              search.companyNo.toUpperCase() === 'KLD'
            "
            >渠道大类：{{ search.transCategoryName }}</span
          >
        </div>
      </div>
      <div v-if="initSearch && result.length === 0">
        <p
          style="
            text-align: center;
            margin-top: 10px;
            color: #999;
            font-size: 14px;
          "
        >
          没有数据
        </p>
      </div>

      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-immediate-check="false"
        infinite-scroll-distance="10"
      >
        <div
          style="background: #fff; margin-top: 20px; padding: 0 10px"
          v-for="(item, index) in result"
          :key="index"
        >
          <div class="result-title">
            <div class="fl info" style="font-size: 14px">
              <p>
                {{ item.transTypeName }}{{ item.dest }}{{ item.goodsType
                }}<span
                  style="color: #000"
                  v-show="search.companyNo.toLowerCase() !== 'kld'"
                  >--{{ item.transType }}</span
                >
              </p>
              <p>实重：{{ item.weight }}KG</p>
              <p>
                价格：{{ item.totalPrice }}{{ item.currency
                }}<b
                  style="font-weight: normal"
                  v-if="parseInt(item.weight) >= 21"
                  >&emsp;单价：{{ item.unitPrice }}{{ item.currency }}</b
                >
              </p>
              <!-- <p v-if="item.businessTypes">业务类型：{{item.businessTypes}}</p> -->
            </div>
            <span
              class="fr"
              @click="detailShow = index"
              v-show="detailShow !== index"
              >详情</span
            >
            <span
              class="fr"
              @click="detailShow = -1"
              v-show="detailShow === index"
              >收起</span
            >
          </div>
          <div class="result-detail" v-show="detailShow === index">
            <p>时效</p>
            <p class="txt" style="color: red">{{ item.timeLimit }}</p>
            <p>
              附加费：<span v-if="item.extraCharge">{{
                item.extraCharge
              }}</span>
              <span v-else>0</span> RMB
            </p>
            <p
              v-show="
                disableFunc.indexOf('6_1') === -1 && search.companyNo !== 'JLTY'
              "
            >
              计算公式
            </p>
            <p
              v-show="
                disableFunc.indexOf('6_1') === -1 && search.companyNo !== 'JLTY'
              "
              class="txt"
              style="color: red"
            >
              {{ item.designFormulas }}
            </p>
            <p @click="getremark(item)">{{ item.remark }}</p>
            <p class="txt" v-if="item.index == '-1' ? true : false">
              {{ remarkdetail }}
            </p>
          </div>
        </div>
      </div>
      <mt-popup style="width: 100%" v-model="popupVisible" position="bottom">
        <div style="background: #fff; height: 240px; width: 100%">
          <div style="padding: 10px">
            <mt-button
              size="small"
              type="default"
              style="float: left"
              @click="popupVisible = false"
              >取消
            </mt-button>
            <mt-button
              size="small"
              type="primary"
              style="float: right"
              @click="typeConfirm()"
              >确定
            </mt-button>
          </div>
          <mt-picker :slots="types" ref="picker"></mt-picker>
        </div>
      </mt-popup>
      <mt-popup style="width: 100%" v-model="popupVisible2" position="bottom">
        <div style="background: #fff; height: 240px; width: 100%">
          <div style="padding: 10px">
            <mt-button
              size="small"
              type="default"
              style="float: left"
              @click="popupVisible2 = false"
              >取消
            </mt-button>
            <mt-button
              size="small"
              type="primary"
              style="float: right"
              @click="typeConfirm2()"
              >确定
            </mt-button>
          </div>
          <mt-picker
            :slots="types2"
            @change="onValuesChange2"
            valueKey="transCategoryName"
          ></mt-picker>
        </div>
      </mt-popup>
      <mt-popup style="width: 100%" v-model="popupVisible4" position="bottom">
        <div style="background: #fff; height: 240px; width: 100%">
          <div style="padding: 10px">
            <mt-button
              size="small"
              type="default"
              style="float: left"
              @click="popupVisible4 = false"
              >取消
            </mt-button>
            <mt-button
              size="small"
              type="primary"
              style="float: right"
              @click="typeConfirm4()"
              >确定
            </mt-button>
          </div>
          <mt-picker
          ref="picker4"
            :slots="types4"
          ></mt-picker>
        </div>
      </mt-popup>
      <mt-popup style="width: 100%" v-model="popupVisible5" position="bottom">
        <div style="background: #fff; height: 240px; width: 100%">
          <div style="padding: 10px">
            <mt-button
              size="small"
              type="default"
              style="float: left"
              @click="popupVisible5 = false"
              >取消
            </mt-button>
            <mt-button
              size="small"
              type="primary"
              style="float: right"
              @click="typeConfirm5()"
              >确定
            </mt-button>
          </div>
          <mt-picker ref="picker5"
            :slots="types5"
          ></mt-picker>
        </div>
      </mt-popup>
      <mt-popup style="width: 100%" v-model="popupVisible6" position="bottom">
        <div style="background: #fff; height: 240px; width: 100%">
          <div style="padding: 10px">
            <mt-button
              size="small"
              type="default"
              style="float: left"
              @click="popupVisible6 = false"
              >取消
            </mt-button>
            <mt-button
              size="small"
              type="primary"
              style="float: right"
              @click="typeConfirm6()"
              >确定
            </mt-button>
          </div>
          <mt-picker ref="picker6"
            :slots="types6"
          ></mt-picker>
        </div>
      </mt-popup>
      <!-- <mt-popup
                    style="width: 100%;"
                    v-model="popupVisible3"
                    position="bottom">
                <div style="background: #fff;height: 240px;width: 100%;">
                    <div style="padding: 10px;">
                        <mt-button size="small" type="default" style="float: left;" @click="popupVisible3=false">取消
                        </mt-button>
                        <mt-button size="small" type="primary" style="float: right;" @click="typeConfirm3()">确定
                        </mt-button>
                    </div>
                    <mt-picker :slots="types3" @change="onValuesChange3"></mt-picker>
                </div>
            </mt-popup> -->
      <oms-destination
        ref="omsDestination"
        @getCountryCode="getDestNo"
      ></oms-destination>
    </div>
  </page>
</template>
<script>
import omsDestination from "@/components/omsDestination";

export default {
  components: {
    omsDestination,
  },
  created() {
    document.title = "报价查询";
    this.search.companyNo = this.$util.get("companyNo");
    if (this.$route.query.from === "out") {
      this.search.weight = this.$route.query.weight;
      this.search.destNo = this.$route.query.destNo;
      this.search.countryName = this.$route.query.destNo;
      this.search.packageType = this.$route.query.packageType;
      this.search.companyNo = this.$route.query.companyNo;
      this.search.originFlag = "out";
      this.searchData();
    }
    this.getTransType();
    // 获取类型
    this.getType();
    this.getPayment();
    this.getPayType();
    this.getDeclareMethod();
  },
  data() {
    return {
      disableFunc: [],
      popupVisible: false,
      popupVisible2: false,
      popupVisible3: false,
      popupVisible4: false,
      popupVisible5: false,
      popupVisible6: false,
      detailShow: -1,
      initSearch: false,
      packageType: "",
      transCategory: "",
      transCategoryName: "",
      businessTypes: "",
      long: "",
      width: "",
      height: "",
      loading: false,
      formShow: true,
      search: {
        companyNo: "",
        destNo: "",
        pageIndex: 1,
        pageSize: 10,
        packageType: "",
        transCategoryName: "全部大类",
        transCategory: "",
        postCode:'',
        payType:'',
        payment:'',
        businessTypes: "",
        destType:null
      },
      types: [{ content: "type1", values: [] }],
      types2: [{ content: "type2", values: [] }],
      types4: [{ content: "type4", values: [] }],
      types5: [{ content: "type5", values: [] }],
      types6: [{ content: "type6", values: [] }],
      result: [],
      types3: [
        {
          content: "type3",
          values: ["海运业务", "空运业务", "快递业务", "邮包业务", "国内业务"],
        },
      ],
      showremark: false,
      remarkdetail: "",
      total: "",
      getPaymentList:[],
      getPayTypeList:[],
      getDeclareMethodList:[],
      declareMethod:'',
      payType:'',
      payment:'',
      declareMethodName:'',
      payTypeName:'',
      paymentName:'',
      isFirst:true,
    };
  },
  methods: {
    getPayment(){
      this.http
        .send({
          command: "common/getPayment",
          params: {
            companyNo: this.search.companyNo,
          },
        })
        .then((res) => {
          this.getPaymentList = res.data.body;
          if (res.data.result_code === 0) {
            res.data.body.forEach((item) => {
              this.types6[0].values.unshift(item.fieldName);
              if (item.isDefault === 1) {
                this.payment = item.fieldName;
                this.search.payment = item.fieldCode;
              }
            });
          }
        });
    },
    getPayType(){
      this.http
        .send({
          command: "common/getPayType",
          params: {
            companyNo: this.search.companyNo,
          },
        })
        .then((res) => {
          this.getPayTypeList = res.data.body;
          if (res.data.result_code === 0) {
            res.data.body.forEach((item) => {
              this.types5[0].values.unshift(item.fieldName);
              if (item.isDefault === 1) {
                this.payType = item.fieldName;
                this.search.payType = item.fieldCode;
              }
            });
          }
        });
    },
    getDeclareMethod(){
      this.http
        .send({
          command: "common/getDeclareMethod",
          params: {
            companyNo: this.search.companyNo,
          },
        })
        .then((res) => {
          this.getDeclareMethodList = res.data.body;
          if (res.data.result_code === 0) {
            res.data.body.forEach((item) => {
              this.types4[0].values.unshift(item.fieldName);
              if (item.isDefault === 1) {
                this.search.declareMethod = item.fieldName;
              }
            });
          }
        });
    },
    getremark(item) {
      let that = this;
      if (item.index == undefined) {
        that.$set(item, "index", "-1");
        if (item.quoteId) {
          that.http
            .send({
              command: "/quotedPrice/findQuoteRemark",
              params: {
                quoteId: item.quoteId,
                companyNo: that.search.companyNo,
              },
            })
            .then((res) => {
              that.remarkdetail = res.data.body.remark;
            });
        }
      } else {
        that.$delete(item, "index", "-1");
      }
    },
    openDestination() {
      this.formShow = false;
      this.$refs.omsDestination.open();
    },
    getDestNo(res) {
      this.formShow = true;
      this.$set(this.search, "countryName", res.name);
      this.$set(this.search, "destNo", res.code);
      this.$set(this.search, "destType", res.destType);
    },
    onValuesChange(obj) {
      console.log(1,obj.values[0])
      this.packageType = obj.values[0];
    },
    onValuesChange2(obj, values) {
      console.log(obj.values[0])
      if (obj && obj.values[0]) {
        this.transCategory = obj.values[0].transCategoryNo;
        this.transCategoryName = obj.values[0].transCategoryName;
      }
    },
    // onValuesChange3(obj) {
    //     this.businessTypes = obj.values[0];
    // },
    onValuesChange4(obj, values) {
      console.log(4,obj.values[0])
      this.declareMethod = obj.values[0];
    },
    onValuesChange5(obj, values) {
      console.log(5,obj.values[0])
      this.payType = obj.values[0];
    },
    onValuesChange6(obj, values) {
      console.log(6,obj.values[0])
      this.payment = obj.values[0];
    },
    typeConfirm() {
      this.search.packageType =  this.$refs.picker.getValues()[0];

      this.popupVisible = false;
    },
    typeConfirm2() {
      this.search.transCategory = this.transCategory;
      this.search.transCategoryName = this.transCategoryName;
      this.popupVisible2 = false;
    },
    typeConfirm4() {
      this.search.declareMethod =  this.$refs.picker4.getValues()[0];
      // this.search.declareMethod = this.declareMethod;
      this.popupVisible4 = false;
    },
    typeConfirm5() {
      this.payType =  this.$refs.picker5.getValues()[0];
      this.getPayTypeList.forEach((item)=> {
        if(item.fieldName == this.payType){
          this.search.payType = item.fieldCode;
        }
      })
      this.popupVisible5 = false;
    },
    typeConfirm6() {
      this.payment =  this.$refs.picker6.getValues()[0];
      this.getPaymentList.forEach((item)=> {
        if(item.fieldName == this.payment){
          this.search.payment = item.fieldCode;
        }
      })
      this.popupVisible6 = false;
    },
    // typeConfirm3() {
    //     this.search.businessTypes = this.businessTypes;
    //     this.popupVisible3 = false;
    // },
    // 获取报价查询类型
    getType() {
      this.http
        .send({
          command: "common/getPackageType",
          params: { companyNo: this.search.companyNo },
        })
        .then((res) => {
          console.log(res);
          if (res.data.result_code === 0) {
            //   this.types[0].values = res.data.body;
            res.data.body.forEach((item) => {
              this.types[0].values.unshift(item.fieldCode);
              if (item.isDefault === 1) {
                this.search.packageType = item.fieldCode;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTransType() {
      this.http
        .send({
          command: "transCategory/getTransCategory",
          params: { companyNo: this.search.companyNo },
        })
        .then((res) => {
          if (res.data.result_code === 0) {
            this.types2[0].values = res.data.body;
          }
          this.types2[0].values.unshift({
            transCategoryName: "全部大类",
            transCategoryNo: "",
          });
        })
        .catch((err) => {
          this.types2[0].values.unshift({
            transCategoryName: "全部大类",
            transCategoryNo: "",
          });
        });
    },
    searchData() {
      if (this.loading) return false;
      if (!this.search.destNo) {
        this.$toast("请选择目的地");
        return;
      }
      if (!this.search.weight) {
        this.$toast("请输入实重");
        return;
      }
      this.initSearch = true;
      this.result = [];
      this.getData();
    },
    floatNumberMultiple(arg1, arg2) {
      let m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    getData(pageIndex = 1, pageSize = 10) {
      if (!this.search.destNo) {
        this.$toast("请选择目的地");
        return;
      }
      if (!this.search.weight) {
        this.$toast("请输入实重");
        return;
      }
      if (this.long && this.width && this.height) {
        let number = this.floatNumberMultiple(this.long, this.width);
        this.search.vol = this.floatNumberMultiple(number, this.height) + "";
      } else {
        this.search.vol = 0 + "";
      }
      this.loading = true;
      this.$indicator.open({
        spinnerType: "fading-circle",
      });
      this.search.pageIndex = parseInt(pageIndex);
      this.search.pageSize = parseInt(pageSize);
      // this.search.vol = this.long*this.width*this.height;
      this.http
        .send({ command: "quotedPrice/selectByWechatNo", params: this.search })
        .then((res) => {
          this.loading = false;
          this.$indicator.close();
          this.total = res.data.body.count;
          this.result = this.result.concat(res.data.body.datas || []);
        })
        .catch((err) => {
          this.loading = false;
          this.$indicator.close();
        });
      this.http
        .send({
          command: "destCountry/putSelectCountry",
          params: {
            companyNo: this.search.companyNo,
            purposeCode: this.search.destNo,
          },
        })
        .then((res) => {});
    },
    loadMore() {
      if (this.loading) return false;
      if (this.total === this.result.length) return false;
      this.search.pageIndex++;
      this.getData(this.search.pageIndex);
    },
  },
};
</script>
<style scoped>
.mt-gap >>> .mint-cell-title{
  width: 125px;
}
.price-page >>> .mint-field-core {
  text-align: right;
}
</style>
<style lang="less" scoped>
.search-title {
  padding-top: 10px;
  text-align: center;
  color: #333;
  font-size: 16px;
}
.search-list {
  padding: 10px 10px 20px;
  span {
    font-size: 12px;
    color: #333;
    background: #f5f5f5;
    padding: 6px 8px;
    border-radius: 4px;
    margin-bottom: 4px;
    display: inline-block;
  }
}
.result-title {
  padding-top: 10px;
  overflow: hidden;
  padding-bottom: 14px;
  .info {
    width: calc(100% - 46px);
    p {
      &:first-child {
        color: #333;
        font-size: 16px;
        margin-bottom: 4px;
      }
      &:nth-child(2) {
        font-size: 14px;
      }
      &:nth-child(3) {
        font-size: 14px;
        color: red;
      }
    }
  }
  span {
    font-size: 14px;
    color: #19a0ff;
    padding-top: 10px;
    padding-right: 10px;
  }
}
.result-detail {
  padding-bottom: 8px;
  .txt {
    font-size: 14px;
    color: #666;
    margin-bottom: 6px;
    margin-top: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/price.vue